// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"4dc17a1c","814":"b4ca170e"}[chunkId] + ".chunk.js";
};